// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__1bT7w","defaultSpacing":"Card_defaultSpacing__3FzJQ"};